import { createContext, useEffect, useMemo, useState } from "react";
import { User } from "../data/entities";
import { ROLE } from "../data/enums";

type AuthenticationContextType = {
    setLoggedIn: any;
    user: User;
    setUser: Function;
};

const defaultUser = {
    is_active: true,
    username: "",
    email: "",
    display_name: "",
    phone_number: "",
    address: "",
    role: ROLE.SALE_STAFF,
    avatar: "",
};

export const AuthenticationContext = createContext<AuthenticationContextType>({
    setLoggedIn: () => {
    },
    setUser: () => {
    },
    user: defaultUser,
});

export const AuthenticationProvider = ({ setLoggedIn, children }: any) => {
    const [user, setUser] = useState(() => {
        const storedUser = localStorage.getItem("user");
        return storedUser ? JSON.parse(storedUser) : defaultUser;
    });

    useEffect(() => {
        const handleStorageChange = () => {
            const storedUser = localStorage.getItem("user");
            setUser(storedUser ? JSON.parse(storedUser) : null);
        };

        // Listen for changes in localStorage
        window.addEventListener("storage", handleStorageChange);

        return () => window.removeEventListener("storage", handleStorageChange);
    }, []);

    const contextValue = useMemo(() => ({ setLoggedIn, setUser, user }), [setLoggedIn, user]);

    return (
        <AuthenticationContext.Provider value={contextValue}>
            {children}
        </AuthenticationContext.Provider>
    );
};
